import { filterPage } from "components/common/Filters/FiltersHelper";
import PlanProgressList from "../PlanProgressList";
import Sections from "../Sections/List";

export const libraryPlanTabs = (selectedPlanDetail: any, planType: string) => {
  return [
    {
      label: "Action Plan",
      content: Hoc(Sections, selectedPlanDetail, planType),
      filtersToClear: [filterPage.planProgressFromLibraryDisplay, filterPage.libraryPlanDetailsDisplay]
    },
    {
      label: "Plan Progress",
      content: PlanProgressList,
      filtersToClear: []
    }
  ];
};

function Hoc(WrappedComponent: any, data: any, planType: string) {
  return function (props: any) {
    return <WrappedComponent {...props} selectedPlanDetail={data} planType={planType} />;
  };
}
